import { RECORD_TYPE } from '@Utils/choiceListMapping';
import { AssetSchema } from '@innovyze/lib_asset_schema';

/**
 * Record types available for an asset type. I360A-2514 removed the legacy
 * per-system/asset allow-list (and the `info-360-rehab-stormwater-rules` flag
 * that opened it), so nothing narrows this list by system type any more.
 *
 * Only three entries are capability-driven: Inspections gates INSPECTION and
 * CONDITION, Risk gates RISK. The rest are unconditional here, and
 * useRecordTypeOptions then filters DETERIORATION_MODEL and FAILURE_DEFINITION
 * by info360-rehab-enable-deterioration-model-results.
 */
export const getRecordTypeOptions = (schema: AssetSchema): RECORD_TYPE[] => {
	const hasInspectionsCapability = schema.hasCapability('Inspections');
	const hasRiskCapability = schema.hasCapability('Risk');

	return [
		...[hasInspectionsCapability && RECORD_TYPE.INSPECTION],
		...[hasInspectionsCapability && RECORD_TYPE.CONDITION],
		...[hasRiskCapability && RECORD_TYPE.RISK],
		RECORD_TYPE.ASSET_ATTRIBUTES,
		RECORD_TYPE.USER_DEFINED_FIELDS,
		RECORD_TYPE.TASK,
		RECORD_TYPE.EVENT,
		RECORD_TYPE.ACTION,
		RECORD_TYPE.DETERIORATION_MODEL,
		RECORD_TYPE.FAILURE_DEFINITION,
	].filter(Boolean) as RECORD_TYPE[];
};
